export default __webpack_public_path__ + "static/media/daily-bonus-ico.9b05f1f5.svg";